// @flow

export function createReducerPart<R>(
  type?: null | string | string[],
  reducer: R,
): { [key: string]: R } {
  if (type == null) {
    return {};
  }

  if (typeof type === 'string') {
    return { [type]: reducer };
  }

  if (Array.isArray(type)) {
    return type.reduce((acc, i) => ({ ...acc, ...createReducerPart(i, reducer) }), {});
  }

  return {};
}

export default createReducerPart;



// WEBPACK FOOTER //
// ./src/store/helpers/createReducerPart.js